import { useEffect } from 'react';

/**
 * Set the browser tab title for the duration of the component's mount.
 *
 * CRA SPA = single static `<title>` in index.html, so without this every
 * tab would read "Real Content. Auto-Posting für Makler" regardless
 * of route. This hook sets the title imperatively on mount and restores
 * the previous value on unmount, so route-by-route titles work in the
 * browser without needing react-helmet-async.
 *
 * Usage:
 *   useDocumentTitle('Pricing. Real Content');
 *
 * For SEO, the static title in `index.html` is what crawlers see; this
 * hook is purely for UX (tab/history/screenreader).
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    if (title) {
      document.title = title;
    }
    return () => {
      document.title = previous;
    };
  }, [title]);
}
